import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df18a2d2cdc1e0/app/(dashboard)/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/tmp/8df18a2d2cdc1e0/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df18a2d2cdc1e0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df18a2d2cdc1e0/provider/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df18a2d2cdc1e0/utils/dateUtils.ts");
